<mp-basic-flyout class="basic-flyout" flyoutTitle="Industriekataloge auswählen" (closed)="cancel()">
  <button class="confirm-button" mat-fab header-action-fab [disabled]="selection.length === 0" (click)="confirm()">
    <mat-icon>check</mat-icon>
  </button>

  <mp-select-all-flyout-elements-button
    class="select-all-flyout-elements-button"
    content-action-fab
    [isAllItemsSelected]="selection.length === (querier.totalKatalogeCount$ | async)"
    [isNoItemsSelected]="selection.length === 0"
    (selectAllClick)="selectAll()"
    (deselectAllClick)="deselectAll()"
  />

  <div class="flyout-content">
    <div class="filter-section">
      <mp-search-field
        class="raised filter-section__search-field"
        placeholder="Kataloge durchsuchen"
        (searched)="handleSearch($event)"
        (cleared)="handleSearch('')"
      />

      <mp-multi-selection-group
        filterName="Katalogtyp"
        icon="menu_book"
        [isExpanded]="false"
        [options]="catalogTypeFilterOptions"
        (selectedValuesChange)="handleFilterChange({ catalogType: $event })"
      />
    </div>

    <mp-infinite-scroll class="search-results" [itemTemplate]="itemTemplate" [dataSource]="dataSource" />
  </div>
</mp-basic-flyout>

<ng-template #itemTemplate let-katalog>
  <mp-selector-item
    class="selector"
    [selected]="katalog.catalogId | isSelectedById: selection"
    [disabled]="excludeIds.includes(katalog.catalogId)"
    (toggled)="toggleSelect(katalog)"
  >
    <div>
      <div class="selector__info">
        @if (katalog.name) {
          <span class="selector__label truncate">{{ katalog.name }}</span>
        }

        @if (katalog.dataSource) {
          <span class="selector__label truncate">{{ katalog.dataSource }}</span>
        }
      </div>
      <div class="selector__title">
        <mp-catalog-type-icon class="catalog-type-icon" [type]="katalog.type" />

        @if (katalog.supplier) {
          <h3>{{ katalog.supplier?.name }}</h3>
        }
      </div>
    </div>
  </mp-selector-item>
</ng-template>
